import React from 'react';
import { FaDownload, FaFilter, FaUpload, FaCalendarAlt } from 'react-icons/fa';
import { useTranslation } from '../../../context/LanguageContext';

const OrderActions = ({
    onExport,
    onToggleFilters,
    showFilters,
    bulkDate,
    onBulkDateChange,
    onBulkUpload,
    bulkUploading
}) => {
    const { t } = useTranslation();
    return (
        <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-semibold text-gray-900">
                {t('admin.title')}
            </h1>
            <div className="flex gap-3 items-center">
                <button
                    onClick={onToggleFilters}
                    className={`px-4 py-2 rounded-lg flex items-center gap-2 transition-all duration-200
                        ${showFilters 
                            ? 'bg-yellow-100 text-yellow-800 hover:bg-yellow-200' 
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                >
                    <FaFilter />
                    {t('admin.filters_title')}
                </button>
                {/* Bulk Upload by Date */}
                <div className="flex items-center gap-2 bg-gray-50 px-3 py-2 rounded-lg">
                    <FaCalendarAlt className="text-gray-600" />
                    <input
                        type="date"
                        value={bulkDate || ''}
                        onChange={(e) => onBulkDateChange && onBulkDateChange(e.target.value)}
                        className="border border-gray-300 rounded px-2 py-1 text-sm"
                    />
                    <button
                        onClick={onBulkUpload}
                        disabled={!bulkDate || bulkUploading}
                        className={`px-3 py-2 rounded-lg flex items-center gap-2 transition-all duration-200 text-white ${(!bulkDate || bulkUploading) ? 'bg-gray-300 cursor-not-allowed' : 'bg-yellow-500 hover:bg-yellow-600 transform hover:scale-105'}`}
                        title="Upload all invoices for selected date"
                    >
                        {bulkUploading ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-1 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                </svg>
                                {t('admin:uploading') || 'Uploading…'}
                            </>
                        ) : (
                            <>
                                <FaUpload />
                                {t('admin:bulk_upload') || 'Bulk Upload ZATCA'}
                            </>
                        )}
                    </button>
                </div>
                <button
                    onClick={onExport}
                    className="px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600
                        transform hover:scale-105 transition-all duration-200 flex items-center gap-2"
                >
                    <FaDownload />
                    {t('admin.export')}
                </button>
            </div>
        </div>
    );
};

export default OrderActions;
